import LoginButton from "./LoginButton/LoginButton";

export const Login = () => {

  return (
    <div className="login"> 
        <h3>Login Page</h3>
        <LoginButton />
    </div>
  );
}